/* eslint-disable class-methods-use-this */
import { ConnectTenantConcern, TenantConcern } from '@models';
import { EntityDto } from 'services/dto';
import { PagedResultDto } from '../dto/pagedResultDto';
import http from '../httpService';
import { Concern, UpdateTenantConcern } from './dto/concern';
import {
  ConcernCategory,
  CreateConcernCategory,
  PagedConcernCategoryRequestDto,
  PagedTenantConcernsRequestDto,
  TenantConcernCategory,
} from './dto/concernCategory';

class ConcernService {
  public async getAllCategories(
    request: PagedConcernCategoryRequestDto
  ): Promise<PagedResultDto<ConcernCategory>> {
    const result = await http.get('api/services/app/ConcernCategory/GetAll', {
      params: request,
    });
    return result.data.result;
  }

  public async getAllTenantConcerns(
    request: PagedTenantConcernsRequestDto
  ): Promise<PagedResultDto<TenantConcern>> {
    const result = await http.get('api/services/app/TenantConcern/GetAll', {
      params: request,
    });
    return result.data.result;
  }

  public async getTenantConcern(id: EntityDto<string>): Promise<TenantConcern> {
    const result = await http.get('api/services/app/TenantConcern/Get', { params: id });
    return result.data.result;
  }

  public async getAllByTenantId(entityDto: EntityDto): Promise<TenantConcernCategory[]> {
    const result = await http.get('api/services/app/TenantConcern/GetAllByTenantId', {
      params: entityDto,
    });
    return result.data.result;
  }

  public async getConcernCategory(entityDto: EntityDto<string>): Promise<ConcernCategory> {
    const result = await http.get('api/services/app/ConcernCategory/Get', {
      params: entityDto,
    });
    return result.data.result;
  }

  public async deleteConcern(entityDto: EntityDto<string>) {
    const result = await http.delete('api/services/app/Concern/Delete', { params: entityDto });
    return result.data;
  }

  public async updateConcern(concern: Concern) {
    const result = await http.put('api/services/app/Concern/Update', concern);
    return result.data.result;
  }

  public async createConcern(concern: Concern): Promise<Concern> {
    const result = await http.post('api/services/app/Concern/Create', concern);
    return result.data.result;
  }

  public async update(concernCategory: CreateConcernCategory) {
    const result = await http.put('api/services/app/ConcernCategory/Update', concernCategory);
    return result.data.result;
  }

  public async create(concernCategory: CreateConcernCategory): Promise<ConcernCategory> {
    const result = await http.post('api/services/app/ConcernCategory/Create', concernCategory);
    return result.data.result;
  }

  public async updateTenantConcern(request: UpdateTenantConcern) {
    const result = await http.put('api/services/app/TenantConcern/Update', request);
    return result.data.result;
  }

  public async connectTenantConcern(request: ConnectTenantConcern) {
    const result = await http.post('api/services/app/TenantConcern/ConnectTenantConcern', request);
    return result.data.result;
  }
}

export default new ConcernService();
